import { Label } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { PromotionRemainingDaysLabel } from "./PromotionRemainingDaysLabel";
import React from "react";
import { SellingPriceDnrInfo } from "../../types/PriceAndPromotionInfo";
import { SellingPriceDnRInfo } from "../../types/EvaluateArticleNew";

type FlashSalesLabelProps = {
    dnrInfos: { [x: string]: SellingPriceDnrInfo } | Record<string, SellingPriceDnRInfo> | undefined;
    flashSalesCounter: number | null | undefined;
};
export function FlashSalesLabel({ dnrInfos, flashSalesCounter }: FlashSalesLabelProps) {
    const flashSaleDnrInfos = Object.values(dnrInfos || {}).filter((dnrInfo) => dnrInfo.flashSale === true);
    const flashSaleDnrInfo = flashSaleDnrInfos.length > 0 ? flashSaleDnrInfos[0] : null;
    const flashCounter =
        flashSalesCounter !== null && flashSalesCounter !== undefined
            ? flashSalesCounter
            : flashSaleDnrInfo?.flashSalesCounter;

    return (
        <>
            {flashCounter && (
                <Label className="label-rectangular label-promotion-flash-sale">
                    <FormattedMessage
                        id="SD_ARTICLECARD_PROMOTION_FLASH_COUNTER"
                        values={{
                            counter: flashCounter
                        }}
                    />
                </Label>
            )}
            {!flashCounter && (flashSaleDnrInfo?.start || flashSaleDnrInfo?.end) && (
                <PromotionRemainingDaysLabel
                    promotionStart={flashSaleDnrInfo.start}
                    promotionEnd={flashSaleDnrInfo.end}
                />
            )}
        </>
    );
}
